/**
 * ShareSocialSheet
 *
 * Helper function to show social sharing sheet using SheetService.
 * Displays social media sharing options for user profiles or content.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { ShareSocialContent, type ShareSocialContentProps } from './components/ShareSocialContent';

/**
 * Show social sharing sheet
 *
 * @param props - ShareSocialContentProps (user or content share props)
 * @param container - Optional container element, screen key string, or null
 * @param screenKey - Optional screen key of the route opening this sheet
 */
const show = (
  props: ShareSocialContentProps,
  container?: HTMLElement | string | null,
  screenKey?: string
) => {
  SheetService.show({
    title: undefined,
    content: (
      <ShareSocialContent {...props} />
    ),
    container: container,
    screenKey: screenKey,
  });
};

// Export the ShareSocialSheet to call as ShareSocialSheet.show(...)
export const ShareSocialSheet = {
  show,
};
